import "./Footer.css";
import logoFooter from "../../assets/img/logo-footer.png";
import phone from "../../assets/img/phone.svg";
import instagram from "../../assets/img/instagram.svg";
import linkedin from "../../assets/img/linkedin.svg";
import youtube from "../../assets/img/youtube.svg";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { openWhatsApp } from "../../utils/whatsapp";
import { openInstagram } from "../../utils/instagram";
import { openLinkedIn } from "../../utils/linkedin";

function Footer() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/mock/imagesFooter.json")
      .then((res) => res.json())
      .then((result) => {
        setImages(result.data);
      });
  }, []);

  const img = {
    phone,
    instagram,
    linkedin,
    youtube,
  };

  const handleSocialLink = (id) => {
    switch (id) {
      case 1:
        openWhatsApp();
        break;
      case 2:
        openInstagram();
        break;
      case 3:
        openLinkedIn();
        break;
      case 4:
        break;
      default:
        break;
    }
  };

  return (
    <>
      <footer id="footer" className="footer">
        <div className="container footer-top">
          <div className="group">
            <div className="footer-about">
              <img
                src={logoFooter}
                alt="Imagem logo empresa"
                className="logo"
              />
              <div className="footer-contact pt-3">
                <p>Presidente Prudente - SP</p>
                <div className="credits">
                  <p>Copyright © Pontes Tecnologia</p>
                  <p>Todos os Direitos Reservados</p>
                </div>
              </div>
            </div>

            <div className="footer-links">
              <h4>Acessos Rápidos</h4>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">Sobre nós</a>
                </li>
                <li>
                  <a href="#solutions">Soluções</a>
                </li>
                <li>
                  <a href="#budget">Orçamento</a>
                </li>
              </ul>
            </div>

            <div className="social-links">
              <h4>Redes Sociais</h4>
              <Row>
                <Col md={12}>
                  <div className="d-flex">
                    {images.map((item, index) => (
                      <div key={index}>
                        <a
                          className="me-2"
                          onClick={() => handleSocialLink(item.id)}
                        >
                          <img src={img[item.image]} alt={item.description} />
                        </a>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
